import {
  Backdrop,
  Grid,
  Paper,
  Box, 
  Typography,
  Tab,
  Tabs,
  Modal, TextField,
  Button, 
  FormControl, InputLabel,Select,
  MenuItem,IconButton,
  Divider, CircularProgress, Checkbox, FormControlLabel, Card, 
  Dialog, DialogActions, DialogContent, DialogTitle
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import DefaultContainer from "../components/DefaultContainer";
import { connect } from "react-redux";
import DefaultHeader from "../components/DefaultHeader";
import Toast from "../components/Snackbar";
import ls from "local-storage";
import Warning from "../components/Warning";
import SkeletonOrder from "../components/SkeletonOrder";
import dayjs from "dayjs";
import { getAreas, getTableGroups, getByTableGroupID, createAndPay,createReservation, getAreaImages } from "../services/Reservation";
import MoneyFormat from "../components/MoneyFormat";
import { getPartnerPolicies } from "../services/Partners";
import customParseFormat from "dayjs/plugin/customParseFormat";

const ReservationConfirmationScreen = ({ props, cartData, userDetail }) => {
    const navigate = useNavigate();
    dayjs.extend(customParseFormat)
    const [categoryIndex, setCategoryIndex] = useState(0);
    const [partnerDetails, setPartnerDetails] = useState(ls.get("sfPartner"));
    const [menus, setMenus] = useState([]);
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [status, setStatus] = useState(0);
    const [width, setWindowWidth] = useState(0);
    const [height, setWindowHeight] = useState(0);
    const [isOpeningHour, setIsOpeningHour] = useState(false);
    const [msgToast, setMsgToast] = useState("");
    const [loading, setLoading] = useState(false);
    const hours = new Date().getHours();
    const minutes = new Date().getMinutes();
    const seconds = new Date().getSeconds();
    const [selectedTab, setSelectedTab] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [reservationModal, setReservationModal] = useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedTable, setSelectedTable] = useState(null);
    const [selectedTableGroup, setSelectedTableGroup] = useState(null);
    const [areas, setAreas] = useState([])
    const [tableGroups, setTableGroups] = useState([])
    const [tableListByGroupID, setTableListByGroupID] = useState([])
    const [customerName, setCustomerName] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].name:"")
    const [customerPhone, setCustomerPhone] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].phone:"")
    const [customerEmail, setCustomerEmail] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].email:"")
    const [description, setDescription] = useState("");
    const [isLoadingReservasi , setIsLoadingReservasi] = useState(false)
    const [partnerPolicies, setPartnerPolicies] = useState([])
    const [isValid, setIsValid] = useState(false)
    const [areaImage, setAreaImage] = useState([])
    const [adult, setAdult] = useState(2)
    const [child, setChild] = useState(0)
    const [maxPerson, setMaxPerson] = useState([])
    const [error, setError] = useState(false);
    const bookingfee_customer_reservation = ls.get('sfPartner').bookingfee_customer_reservation;
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg] = React.useState("");


    const getPartnerPoliciesF = async (id) => {
          const response  = await getPartnerPolicies(id);
          const policies = response.policies; 
          return policies
        }

    useEffect(()=>{
          getPartnerPoliciesF(ls.get('sfPartner').id).then(data => {
            setPartnerPolicies(data)
          })
        },[])
    // Initialize checked state for each policy
    const [checkedItems, setCheckedItems] = useState(
      partnerPolicies.reduce((acc, item) => {
        acc[item.id] = false; // Ensure each item starts unchecked
        return acc;
      }, {})
    );
    
    useEffect(() => {
      if (partnerPolicies.length === 0) {
        setIsValid(true); // If no policies, set isValid to true
      } else {
        // Check if all checkboxes are checked
        const allChecked = partnerPolicies.every((item) => checkedItems[item.id]);
        setIsValid(allChecked);
      }
    }, [checkedItems, partnerPolicies]);
    
    // Handle checkbox change
    const handleCheckboxChange = (id) => {
      setCheckedItems((prev) => ({
        ...prev,
        [id]: !prev[id],
      }));
    };

    const handleSubmit = async () => {
        if(ls.get('reservation_time').selectedTable){
            setIsLoadingReservasi(true)
            console.log(ls.get('reservation_time').customDate);
            console.log(ls.get('reservation_time').customTime);
            
            
            const startTimeDate = dayjs(ls.get('reservation_time').customDate,"DD-MM-YYYY").format("YYYY-MM-DD") + " " + ls.get('reservation_time').customTime + ":00"
            const reservationData = {
            phone:customerPhone,
            name:customerName,
            email:customerEmail,
            description:description,
            reservation_time: startTimeDate,
            end_time:dayjs(startTimeDate).add(ls.get('reservation_time').selectedTable.duration,ls.get('reservation_time').selectedTable.duration_metric).format("YYYY-MM-DD HH:mm:ss"),
            frID:ls.get('reservation_time').selectedTable.id,
            partner_id:ls.get('sfPartner').id,
            user_id:ls.get('redux_localstorage_simple').userData[0].id,
            pax:ls.get('reservation_time').adult+ls.get('reservation_time').child,
            booking_price: bookingfee_customer_reservation==="1" ?
                                ls.get('reservation_time').adult*ls.get('reservation_time').selectedTable?.booking_price
                                :
                                ls.get('reservation_time').selectedTable?.booking_price
            }
        
        
            const endTime = dayjs(reservationData.end_time, "YYYY-MM-DD HH:mm:ss"); 
            const closingTime = dayjs(`${endTime.format("YYYY-MM-DD")} ${ls.get('sfPartner').jam_tutup}`, "YYYY-MM-DD HH:mm:ss");
            console.log(endTime);
            console.log(closingTime);
            
            
            // Now you can safely compare
            if (endTime.isAfter(closingTime, "second")) {
                setStatus(0)
                setMsg("Durasi reservasi untuk meja ini melebihi jam tutup, silakan lakukan reservasi pada jam lain")
                setTimeout(() => {
                    setIsOpen(true);
                    // Hide after 3 seconds (adjust timing as needed)
                    setTimeout(() => {
                    setIsOpen(false);
                    }, 3000);
                }, 300);
            } if (ls.get('reservation_time').adult+ls.get('reservation_time').child > ls.get('reservation_time').selectedTable.capacity){
                setIsDialogOpen(true)
            } 
            else {
                console.log(reservationData)
                await createAndPay(reservationData).then((response) => {
                if(response.success===1){
                    const invoiceUrl = response.invoice_url
                    setStatus(1)
                    setMsg(invoiceUrl ?
                        "Berhasil Membuat Reservasi, anda akan diarahkan ke halaman pembayaran"
                        :
                        "Berhasil Membuat Reservasi, silahkan bayar reservasi melalui link yang diberikan pada pesan whatsapp anda")
                    setTimeout(() => {
                        setIsOpen(true);
                    
                        // Hide after 3 seconds (adjust timing as needed)
                        setTimeout(() => {
                        setIsOpen(false);
                        if(invoiceUrl){
                            // same tab, supaya redirectUrl dari payment gateway kembali ke halaman ini
                            window.location.href = invoiceUrl
                        }else if(response.iid){
                            navigate(`/history-detail?id=${response.iid}`)
                        }else{
                            navigate(`/?partnerID=${ls.get('sfPartner').id}`)
                        }
                        }, 2000);
                    
                    }, 300);
                }else{
                    setStatus(0)
                    setMsg(response.msg)
                    setTimeout(() => {
                        setIsOpen(true);
                    
                        // Hide after 3 seconds (adjust timing as needed)
                        setTimeout(() => {
                        setIsOpen(false);
                        }, 3000);
                    
                    }, 300);
                }
                });
            }
        }else{
            setIsLoadingReservasi(true)
                const startTimeDate = dayjs(ls.get('reservation_time').customDate,"DD-MM-YYYY").format("YYYY-MM-DD") + " " + ls.get('reservation_time').customTime + ":00"
                const reservationData = {
                phone:customerPhone,
                name:customerName,
                email:customerEmail,
                description:description,
                reservation_time: startTimeDate,
                end_time:dayjs(startTimeDate).add(2,"hours").format("YYYY-MM-DD HH:mm:ss"),
                frID:selectedTable?.id,
                persons:ls.get('reservation_time').adult+ls.get('reservation_time').child,
                partner_id:ls.get('sfPartner').id,
                user_id:ls.get('redux_localstorage_simple').userData[0].id
            }
        
            console.log(reservationData);
            const endTime = dayjs(reservationData.end_time, "YYYY-MM-DD HH:mm:ss"); 
            const closingTime = dayjs(`${endTime.format("YYYY-MM-DD")} ${ls.get('sfPartner').jam_tutup}`, "YYYY-MM-DD HH:mm:ss");
            console.log(endTime);
            console.log(closingTime)
            
            // Now you can safely compare
            if (endTime.isAfter(closingTime, "second")) {
                setStatus(0)
                setMsg("Durasi reservasi untuk meja ini melebihi jam tutup, silakan lakukan reservasi pada jam lain")
                setTimeout(() => {
                    setIsOpen(true);
                    // Hide after 3 seconds (adjust timing as needed)
                    setTimeout(() => {
                    setIsOpen(false);
                    }, 3000);
                }, 300);
            }if (ls.get('reservation_time').adult+ls.get('reservation_time').child > ls.get('sfPartner').max_people_reservation){
                setIsDialogOpen(true)
                // setStatus(0)
                // setMsg("Jumlah orang melebihi kapasitas yang diijinkan, silahkan hubungi merchant")
                // setTimeout(() => {
                //     setIsOpen(true);
                //     // Hide after 3 seconds (adjust timing as needed)
                //     setTimeout(() => {
                //       setIsOpen(false);
                //     }, 3000);
                //   }, 300);
            }  
            else {
                console.log(reservationData);
                
                await createReservation(reservationData).then((response) => {
                console.log(response);
                
                if(response.success===1){
                    setStatus(1)
                    setMsg("Berhasil Membuat Reservasi")
                    setTimeout(() => {
                        setIsOpen(true);
                    
                        // Hide after 3 seconds (adjust timing as needed)
                        setTimeout(() => {
                        setIsOpen(false);
                        navigate(`/history-detail?id=${response.iid}`)
                        }, 2000);
                    
                    }, 300);
                }else{
                    setStatus(0)
                    setMsg(response.msg)
                    setTimeout(() => {
                        setIsOpen(true);
                    
                        // Hide after 3 seconds (adjust timing as needed)
                        setTimeout(() => {
                        setIsOpen(false);
                        }, 3000);
                    
                    }, 300);
                }
                });
            }
        }
        
          setIsLoadingReservasi(false)
      }

    return (
        <DefaultContainer>
            <Box sx={{bgcolor:"white", mx:3, mt:10}} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight="bold">
                    Detail Reservasi
                    </Typography>
            </Box>
            <Toast isOpen={isOpen} message={msg} status={status} sx={{maxWidth:"480px"}} />         
            
            <Box display="flex" alignItems="center" p={2}>
            {/* Image Section */}
            <Box
                component="img"
                src={ls.get('sfPartner').img_map}
                alt="image-partner"
                sx={{
                width: 60,  // Set fixed width
                height: 60, // Set fixed height
                borderRadius: 1, // Slightly rounded corners
                objectFit: "cover", // Keep image aspect ratio
                backgroundColor: "#000" // Match black background if needed
                }}
            />
            
            {/* Text Section */}
            <Box ml={2}>
                <Typography variant="h6" fontWeight="bold">
                {ls.get('sfPartner').name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                {ls.get('sfPartner').address}
                </Typography>
            </Box>
            </Box>

            <Divider sx={{ my: 2 }} />

            
            <Typography fontWeight="bold" mx={3}>Ringkasan Reservasi</Typography>
            <Typography mx={3}>📅 {`${ls.get('reservation_time').customDate} ${ls.get('reservation_time').customTime} - ${dayjs(ls.get('reservation_time').customDate + " " + ls.get('reservation_time').customTime + ":00", "DD-MM-YYYY HH:mm:ss").add(+2, "hours").format("HH:mm")}`}</Typography>
            {ls.get('reservation_time').selectedTable &&
                <Typography mx={3}>🍽️ {ls.get('reservation_time').selectedTable?.name + ` (${ls.get('reservation_time').selectedTable?.idmeja})`}</Typography>
                }
            <Typography mx={3}>👤 {`${ls.get('reservation_time').adult} Dewasa` + (ls.get('reservation_time').child>0? ` + ${ls.get('reservation_time').child} Anak`:``)}</Typography>
            <Divider sx={{ my: 2 }} />

            
            <Typography mx={3} fontWeight="bold">Detail Pemesan</Typography>
            <Typography mx={3}><TextField
                                    sx={{p:0, mt:1}}
                                    variant="outlined"
                                    label={"👤 Nama"}
                                    type="text"
                                    autoFocus
                                    defaultValue={ls.get('redux_localstorage_simple').userData[0]?.name}
                                    onChange={(e) => {
                                        setCustomerName(e.target.value);
                                    }}
                                    error={customerName && !/^[a-zA-Z\s]+$/.test(customerName)}
                                    helperText={customerName && !/^[a-zA-Z\s]+$/.test(customerName) ? "Only letters & spaces allowed" : ""}
                                    />
            </Typography> 
            <Typography mx={3}><TextField
                                    sx={{p:0, mt:1}}
                                    variant="outlined"
                                    label={"📞 No. Telpon"}
                                    type="tel"
                                    autoFocus
                                    defaultValue={ls.get('redux_localstorage_simple').userData[0]?.phone}
                                    onChange={(e) => {
                                        setCustomerPhone(e.target.value);
                                    }}
                                    error={customerPhone && !/^\d+$/.test(customerPhone)}
                                    helperText={customerPhone && !/^\d+$/.test(customerPhone) ? "Invalid phone number" : ""}
                                    />
            </Typography>
            <Typography mx={3}><TextField
                                    sx={{p:0, mt:1}}
                                    variant="outlined"
                                    label={"📧 Email"}
                                    type="email"
                                    autoFocus
                                    defaultValue={ls.get('redux_localstorage_simple').userData[0]?.email}
                                    onChange={(e) => {
                                        setCustomerEmail(e.target.value);
                                    }}
                                    error={customerEmail && !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(customerEmail)}
                                    helperText={customerEmail && !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(customerEmail) ? "Invalid email format" : ""}
                                    /> 
            </Typography>
            <Typography mx={3} color={"#979797"} fontSize={10}>*Notes : Jika ingin melakukan reservasi untuk orang lain, silakan ganti detail pemesan</Typography>
            <Divider sx={{ my: 2 }} />

            <Typography mx={3} fontWeight="bold">Catatan Tambahan</Typography>
            <TextField onChange={(e)=> setDescription(e.target.value)}placeholder="Masukkan catatan tambahan" sx={{width:"92%", ml:2 , mr:5}}/>
            
            <Divider sx={{ my: 2 }} />
            
            {partnerPolicies.length>0 &&
                <Typography mx={3} fontWeight="bold">Untuk melengkapi proses reservasi</Typography>
            }
                            {partnerPolicies.map((item) => (
                            <Typography mx={3} key={item.id}>
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    checked={checkedItems[item.id] || false}
                                    onChange={() => handleCheckboxChange(item.id)}
                                    />
                                }
                                label={item.description}
                                />
                            </Typography>
                            ))}
                            {/* <Typography color={isValid ? "green" : "red"}>
                            {isValid ? "All policies are checked ✅" : "Please check all policies ❌"}
                            </Typography> */}
                            
            {partnerPolicies.length>0 && <Divider sx={{ my: 2 }} />}

            {ls.get('reservation_time').selectedTable && <Typography mx={3} fontWeight="bold">Detail Tagihan</Typography>}
            {ls.get('reservation_time').selectedTable &&<Typography mx={3}>Minimum Spend: <MoneyFormat value={ls.get('reservation_time').selectedTable?.minimum_transaction}/></Typography>}
            {ls.get("reservation_time").selectedTable && (
            <Typography mx={3}>
                Booking Fee:{" "}
                {bookingfee_customer_reservation === "1" ? (
                <Typography component="span">
                    <MoneyFormat value={ls.get("reservation_time").selectedTable?.booking_price} /> /adult
                </Typography>
                ) : (
                <MoneyFormat value={ls.get("reservation_time").selectedTable?.booking_price} />
                )}
            </Typography>
            )}

            {ls.get("reservation_time").selectedTable && (
            <Typography mx={3} fontWeight="bold" color="primary">
                Total:{" "}
                {bookingfee_customer_reservation === "1" ? (
                <Typography component="span">
                    <MoneyFormat
                    value={ls.get("reservation_time").selectedTable?.booking_price * ls.get("reservation_time").adult}
                    />
                </Typography>
                ) : (
                <MoneyFormat value={ls.get("reservation_time").selectedTable?.booking_price} />
                )}
            </Typography>
            )}



            <Grid fullWidth sx={{display:"flex", alignItems:"center", justifyContent:"center", alignContent:"center"}}>
                {isLoadingReservasi ? 
                <CircularProgress/>
                :
                <Button
                disabled={!isValid}
                variant="contained"
                color="primary"
                style={{ 
                    marginTop: 16,
                    width: "50%", 
                    color: "white" // Warna teks
                }}
                // sx={{ mt: 2,width:"50%", color:"white"}}
                onClick={()=>handleSubmit()}
                >
                Buat Reservasi
                </Button>}
            </Grid>
            <Grid fullWidth sx={{display:"flex", alignItems:"center", justifyContent:"center", alignContent:"center"}}>
                {ls.get('reservation_time').selectedTable ? 
                    <Button style={{ 
                            marginTop: 5,
                            marginBottom: 16, 
                            width: "50%", 
                            // color: "white" // Warna teks
                        }}
                        onClick={()=> navigate('/select-table', {state:{customTime:ls.get('reservation_time').customTime, customDate:ls.get('reservation_time').customDate, adult:ls.get('reservation_time').adult, child:ls.get('reservation_time').child}})}>
                            Pilih meja lain
                    </Button>
                    :
                    <Button onClick={()=> navigate('/reservation-non-special?=partnerID='+ls.get('sfPartner').id, {state:{customTime:ls.get('reservation_time').customTime, customDate:ls.get('reservation_time').customDate, adult:ls.get('reservation_time').adult, child:ls.get('reservation_time').child}})}>
                        Pilih jam lain
                    </Button>
                }
            </Grid>
            {isDialogOpen &&
                        <Dialog
                          open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                              <DialogTitle>Informasi</DialogTitle>
                              <DialogContent sx={{maxWidth:"320px"}}>
                                  {ls.get('reservation_time').selectedTable ? 
                                    <Typography>Jumlah orang melebihi kapasitas meja, silakan hubungi merchant</Typography>
                                    :
                                    <Typography>Jumlah orang melebihi kapasitas yang diijinkan, silakan hubungi merchant</Typography>
                                    }
                              </DialogContent>
                              <DialogActions>
                                  <Button sx={{color:"#7f7f7f"}} onClick={() => setIsDialogOpen(false)} color="primary">
                                      Tutup
                                  </Button>
                                  <Button onClick={() => { 
                                    // 1. Menghilangkan karakter selain angka
                                      let formatted = partnerDetails.phone.replace(/\D/g, "");
            
                                    // 2. Menghilangkan angka 0 di depan (prefix)
                                    //    Kemudian diganti dengan 62
                                      if (formatted.startsWith("0")) {
                                        formatted = "62" + formatted.substr(1);
                                      }
                                      window.open("http://wa.me/" + formatted, "_blank");
                                    }} color="primary">
                                      Hubungi merchant
                                  </Button>
                              </DialogActions>
                          </Dialog>
                        }
        </DefaultContainer>
    )

}
const mapStateToProps = (state) => {
    return {
      currency: state.currencyData,
      // cartData: state.cartData,
      cartData: state.cartData.filter(
        (data) => data.partnerID === ls.get("partnerID")
      ),
      userDetail: state.userData[state.userData.length - 1],
      wishlistData: state.wishlistData,
      compareData: state.compareData,
    };
  };
  
  export default connect(mapStateToProps, null)(ReservationConfirmationScreen);